import React from 'react'

const ManageCarrierConnectionDialogContext = React.createContext()

export default ManageCarrierConnectionDialogContext
